/**
 * Snackbar éphémère réutilisable.
 *
 * showSnackbar({ message, actionLabel, onAction, duration })
 *   message     — texte affiché
 *   actionLabel — libellé du bouton d'action (ex: "ANNULER")
 *   onAction    — callback appelé si l'utilisateur clique le bouton
 *   duration    — ms avant disparition automatique (défaut : 4000)
 */

// Hôte unique injecté une seule fois dans <body>
let host = null;
let hideTimer = null;
let currentSnackbar = null;

function getHost() {
  if (!host) {
    host = document.createElement('div');
    host.className = 'snackbar-host';
    host.setAttribute('aria-live', 'polite');
    host.setAttribute('aria-atomic', 'true');
    document.body.appendChild(host);
  }
  return host;
}

function dismiss(immediate = false) {
  if (!currentSnackbar) return;

  if (hideTimer !== null) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }

  if (immediate) {
    currentSnackbar.remove();
    currentSnackbar = null;
    return;
  }

  currentSnackbar.classList.add('is-hiding');
  currentSnackbar.addEventListener(
    'animationend',
    () => {
      currentSnackbar?.remove();
      currentSnackbar = null;
    },
    { once: true }
  );
}

export function showSnackbar({ message, actionLabel, onAction, duration = 4000 }) {
  // Remplace la snackbar courante sans empiler
  dismiss(true);

  const el = document.createElement('div');
  el.className = 'snackbar';
  el.setAttribute('role', 'status');

  const msg = document.createElement('span');
  msg.className = 'snackbar-message';
  msg.textContent = message;
  el.appendChild(msg);

  if (actionLabel && onAction) {
    const btn = document.createElement('button');
    btn.className = 'snackbar-action';
    btn.textContent = actionLabel;
    btn.addEventListener('click', () => {
      dismiss(true);
      onAction();
    });
    el.appendChild(btn);
  }

  currentSnackbar = el;
  getHost().appendChild(el);

  hideTimer = setTimeout(() => dismiss(), duration);
}

export function dismissSnackbar() {
  dismiss(true);
}
